import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_SUCCESS,

  GET_ACCOUNT,
  GET_ACCOUNT_ERROR,
  GET_ACCOUNT_SUCCESS,

  GET_ACCOUNTS,
  GET_ACCOUNTS_ERROR,
  GET_ACCOUNTS_SUCCESS,

  SAVE_ACCOUNT,
  SAVE_ACCOUNT_ERROR,
  SAVE_ACCOUNT_SUCCESS,
} from './constants';

export default {
  async [DELETE_ACCOUNT]({ commit }, data) {
    try {
      commit(DELETE_ACCOUNT);
      const response = await axios({
        url: `${process.env.API_URL}/api/multipleaccounts/delete`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(DELETE_ACCOUNT_SUCCESS, response.data);
      // router.push({ name: 'Settings Accounts' });
    } catch (err) {
      commit(DELETE_ACCOUNT_ERROR, err);
    }
  },

  async [GET_ACCOUNT]({ commit }, accountID) {
    try {
      commit(GET_ACCOUNT);
      const response = await axios({
        url: `${process.env.API_URL}/api/accounts/${accountID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ACCOUNT_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ACCOUNT_ERROR, err);
    }
  },

  async [GET_ACCOUNTS]({ commit }, syndicateID) {
    try {
      commit(GET_ACCOUNTS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/accounts`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ACCOUNTS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ACCOUNTS_ERROR, err);
    }
  },

  async [SAVE_ACCOUNT]({ commit }, data) {
    try {
      commit(SAVE_ACCOUNT);
      let url = `${process.env.API_URL}/api/accounts`;
      let method = 'POST';
      if (data.account && data.account.accountID) {
        url = `${url}/${data.account.accountID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data: data.account ? data.account : data,
      });
      commit(SAVE_ACCOUNT_SUCCESS, { account: response.data, rowIndex: data.rowIndex });
      if (method === 'POST') {
        router.push({ name: 'Settings Accounts' });
      }
    } catch (err) {
      commit(SAVE_ACCOUNT_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Accounts/actions.js